<template>
  <div class="menu-container">
    <div class="menu-item" @click="onToggleSubMenuItem" :class="{'active': isToggleSubmenu}">
      <div class="menu-item-detail">
        <div class="menu-item-key">Project</div>
        <div class="menu-item-name">{{ projectTitle || '-' }}</div>
      </div>
      <div class="action-icon">
        <i class="fa" :class="[isToggleSubmenu ? 'fa-chevron-up' : 'fa-chevron-down']" />
      </div>
    </div>
    <slot name="projectsubmenu" v-if="isToggleSubmenu"></slot>
  </div>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
    },
    projectTitle: {
      type: String,
      default: '-',
    },
    subMenu: {
      type: Array,
      default: () => [],
    },
    showProjectConfig: {
      type: Boolean,
    },
    isToggleSubmenu: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onToggleSubMenuItem() {
      this.$emit('isToggleSubmenu');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/menu.scss';
</style>
